import { AppContext } from 'next/app';
import { isBrowser } from './isBrowser';

export function getUserAgent(ctx: AppContext['ctx']) {
  const headerUserAgent = ctx.req?.headers['user-agent'];
  if (headerUserAgent) return headerUserAgent;
  if (!isBrowser) return '';

  if (typeof window.navigator !== 'undefined') {
    return window.navigator.userAgent;
  }
  return '';
}
